<div class="transaction-header">
    <div class="transaction-info">
      <span class="title">Transaction Details</span><br>
      <span><img class="rounded-circle" style="width: 35px" src="{{ transaction.coinLogoUrl }}" alt="activity-user" />&nbsp;{{ transaction.txnType }}&nbsp;({{transaction.coin_symbol}})</span><br> 
          <!-- <p class="mb-1 text-muted" style="margin-left:40px;line-height: 6px;">{{element.coin_symbol}}</p> -->
      <span class="subtitle">
        Transaction Action:
        {{getTransactionMethod(transaction.txnOperation | titlecase,transaction.redeemedGoldName)}}
        {{transaction.coinsqty}}
        (${{formatNumberWithCommas(transaction.totalAmountTxn)}})
      </span>
    </div>
    <div class="transaction-home" >
      <img src="assets/img/home.png" alt="home" (click)="resetPage()" /> 
      <!-- <button class="btn btn-outline-success" style="width:75px" (click)="resetPage()">Home</button> -->
    </div>
  </div>
  
  <mat-card class="summary-card" style="min-height:600px;background-color: #fff" *ngIf="!isMobile">      
    <div class="card-container" >
            
      <div class="left-column" style="line-height: 40px">
            <p>Transaction Hash:</p>
            <p>Method:</p>
            <p>Status:</p>
            
            <p>Timestamp: </p>
            <p>From: </p>
            <p>To: </p>
            <p style="word-spacing: -6px;">Stablecoins & Tokens: </p>
            <p>Quantity: </p>
            <p>Value: </p>
            <p>Nonce: </p>
            
            <!-- <div class="divider"></div> -->
      </div>
     
      <div class="right-column" style="line-height: 40px">
          
        <!-- 80% Column getPriceWithCoinUnit(transaction.coinsqty,transaction.txnType,transaction.txnTransferOperationType)-->
        <p>{{transaction.txnNum}}&nbsp;</p>
        <p>{{ getTransactionMethod(transaction.txnOperation | titlecase,transaction.redeemedGoldName) }}&nbsp;</p>
        <p style="color: forestgreen;font-weight: 600">{{transaction.status | titlecase}}&nbsp;</p>
        <p style="word-spacing: -8px;">{{transaction.creationDate?(transaction.creationDate|date :'MMM d, y, h:mm:ss a'):''}}&nbsp; </p>
        <p>0X{{transaction.senderHex}}&nbsp;</p>
        <p>0X{{transaction.receiverHex }}&nbsp;</p>
        <!-- <p>{{getCoinType(transaction.txnType)}}&nbsp; </p> -->
        <p>{{transaction.txnType}}&nbsp; </p>
        <p style="word-spacing: -6px;">{{transaction.coinsqty?transaction.coinsqty:""}}&nbsp; </p>
        <p>${{formatNumberWithCommas(transaction.totalAmountTxn) }}&nbsp; </p>
        <p>{{transaction.nounce}}&nbsp;</p>
        <!-- <div class="divider"></div> -->
      </div>
      </div>
    </mat-card>
 <mat-card *ngIf="isMobile" class="mobile-cards" class="txn-card" >
      <!-- <mat-card-header>
        <mat-card-title>Transaction Details</mat-card-title>
      </mat-card-header> -->
      <mat-card-content >
        <div class="txn-grid">
          <div class="txn-item" >
            <div class="txn-label">Transaction Hash</div>
            <div class="txn-value" >{{transaction.txnNum}}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">Method</div>
            <div class="txn-value" ><span  class="badge method-buy">{{ getTransactionMethod(transaction.txnOperation | titlecase,transaction.redeemedGoldName)  }}</span>&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">Status</div>
            <div class="txn-value" >{{transaction.status | titlecase}}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">Timestamp</div>
            <div class="txn-value" >{{transaction.creationDate?(transaction.creationDate|date :'MMM d, y, h:mm:ss a'):''}}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">From</div>
            <div class="txn-value" >0X{{transaction.senderHex}}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">To</div>
            <div class="txn-value" >0X{{transaction.receiverHex}}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">Stablecoins & Tokens</div>
            <div class="txn-value" >{{transaction.txnType}}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">Quantity</div>
            <div class="txn-value" >{{transaction.coinsqty?transaction.coinsqty:""}}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">Value</div>
            <div class="txn-value" >${{formatNumberWithCommas(transaction.totalAmountTxn) }}&nbsp;</div>
          </div>
          <div class="txn-item" >
            <div class="txn-label">Nonce</div>
            <div class="txn-value" >{{transaction.nounce}}&nbsp;</div>
          </div>
        </div>
      </mat-card-content>
      
    </mat-card> 
   
    
  